module.exports = __webpack_public_path__ + "514de6c50f4f94ab43cbba186bafc75a.png";